import { render, staticRenderFns } from "./logon.vue?vue&type=template&id=64048e21&scoped=true&"
import script from "./logon.vue?vue&type=script&lang=js&"
export * from "./logon.vue?vue&type=script&lang=js&"
import style0 from "./logon.vue?vue&type=style&index=0&id=64048e21&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64048e21",
  null
  
)

export default component.exports